import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { useHistory, NavLink } from "react-router-dom";

import MakeAPICall from "../../apiCalls/common";

import { updateConstantsApiRoute } from "../../apiRoutes";

import { getConstants } from "../../reduxStore/actions/serverConstants";

import appRoutes from "../../routes/appRoutes";

import { MAX_FILE_SIZE, DOCS_FORMATS } from "../../constants/constants";

import Loader from "../../components/loader";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import ICPhoneInput from "../../components/form/phoneInput";
import Error from "../../components/error";
import CustomModal from "../../components/modal";

const EditLegalPage = props => {
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [tcFileErr, setTcfileErr] = useState("");
  const [instantExtrasFileErr, setInstantExtrasFileErr] = useState("");
  const [ppFileErr, setPpFileErr] = useState("");
  const [dvpFileErr, setDvpFileErr] = useState("");
  const [dsaFileErr, setDsaFileErr] = useState("");
  const [goodPracticePolicyFileErr, setGoodPracticePolicyFileErr] = useState("");
  const [myHealthRecordSecurityFileErr, setMyHealthRecordSecurityFileErr] = useState("");
  const [myHealthRecordTrainingFileErr, setMyHealthRecordTrainingFileErr] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");


  const updateData = data => {
    setIsProcessing(true);
    var form = new FormData();
    form.append("email", data.email);
    form.append("phoneNumber", data.phoneNo);

    if (data.ppFile) {
      form.append("privacyPolicy", data.ppFile);
    }
    if (data.tcFile) {
      form.append("terms", data.tcFile);
    }
    if (data.instantExtrasFile) {
      form.append("instantExtraTermsConditions", data.instantExtrasFile);
    }
    if (data.dvpFile) {
      form.append("validationProcess", data.dvpFile);
    }
    if (data.dsaFile) {
      form.append("serviceAgreement", data.dsaFile);
    }

    if (data.goodPracticePolicyFile) {
      form.append("goodPracticePolicy", data.goodPracticePolicyFile);
    }
    if (data.myHealthRecordSecurityFile) {
      form.append("myHealthRecordSecurityAndAccessPolicy", data.myHealthRecordSecurityFile);
    }
    if (data.myHealthRecordTrainingFile) {
      form.append("myHealthRecordTrainingPolicy", data.myHealthRecordTrainingFile);
    }
    console.log("Data is here: ", data);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: updateConstantsApiRoute,
      dataObj: form,
      successCallback: async res => {
        setIsProcessing(false);
        setErrModalText("Legal Details Updated Successfully");
        setShowErrModal(true);

        props.getConstants();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    props.getConstants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // validate input file
  const validateFile = (file, field) => {
    let error = "";
    if (file) {
      if (file.size >= MAX_FILE_SIZE) {
        error = "Maximum 2MB file is allowed";
      } else if (!DOCS_FORMATS.includes(file.type)) {
        error = "File must be one of these formats only jpg, png, svg or pdf";
      }
    }

    if (field === "tcFile") {
      setTcfileErr(error);
    }
    if (field === "ppFile") {
      setPpFileErr(error);
    }
    if (field === "instantExtrasFile") {
      setInstantExtrasFileErr(error);
    }
    if (field === "dvpFile") {
      setDvpFileErr(error);
    }
    if (field === "dsaFile") {
      setDsaFileErr(error);
    }
    if (field === "goodPracticePolicyFile") {
      setGoodPracticePolicyFileErr(error);
    }
    if (field === "myHealthRecordSecurityFile") {
      setMyHealthRecordSecurityFileErr(error);
    }
    if (field === "myHealthRecordTrainingFile") {
      setMyHealthRecordTrainingFileErr(error);
    }

    if (error !== "") {
      return false;
    }
    return true;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: props.serverConstants ? props.serverConstants.email : "",
      phoneNo: props.serverConstants ? props.serverConstants.phoneNumber : "",
      instantExtrasFile: null,
      ihFile: null,
      ppFile: null,
      dvpFile: null,
      dsaFile: null,
      goodPracticePolicyFile: null,
      myHealthRecordSecurityFile: null,
      myHealthRecordTrainingFile: null,
      tc: props.serverConstants ? props.serverConstants.terms : "#",
      is: props.serverConstants ? props.serverConstants.isTerms : "#",
      ih: props.serverConstants ? props.serverConstants.ihTerms : "#",
      pp: props.serverConstants ? props.serverConstants.privacyPolicy : "#",
      goodPracticeP: props.serverConstants ? props.serverConstants.goodPracticePolicy : "#",
      dvp: props.serverConstants
        ? props.serverConstants.validationProcess
        : "#",
      dsa: props.serverConstants ? props.serverConstants.serviceAgreement : "#",
      myHealthRecordSecurity: props.serverConstants ? props.serverConstants.myHealthRecordSecurityAndAccessPolicy : "#",
      myHealthRecordTraining: props.serverConstants ? props.serverConstants.myHealthRecordTrainingPolicy : "#"
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter the Email Address"),
      phoneNo: Yup.string()
        .min(5, "Phone number cannot be less than 5 digits")
        .required("Please enter Phone Number")
    }),
    onSubmit: values => {
      updateData(values);
    }
  });

  return (
    <div className="view-ticket-container">
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomModal
          useOneButton={true}
          cancelText="OKAY"
          openModal={showErrModal}
          cancelEvent={() => {
            if (errModalText === "Legal Details Updated Successfully") {
              history.push(appRoutes.viewLegal);
            }
            setShowErrModal(false);
            setErrModalText("");
          }}
          modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
        />
        <div className="d-flex flex-column flex-wrap">
          <NavLink
            to={appRoutes.viewLegal}
            className="details-back-link"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 back-btn-text"> Back to Legal</span>
          </NavLink>
          <br />
          <h3>Edit Legal Details</h3>
          <form className="w-100 mt-4" onSubmit={formik.handleSubmit}>
            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">Email Address:</p>
              <div className="col-sm-5">
                <ICInput
                  name="email"
                  type="text"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.email && formik.errors.email ? true : false
                  }
                  helperText={
                    formik.touched.email && formik.errors.email
                      ? formik.errors.email
                      : ""
                  }
                />
              </div>
            </div>
            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">Phone Number:</p>
              <div className="col-sm-5">
                <ICPhoneInput
                  name="phoneNo"
                  value={formik.values.phoneNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.phoneNo && formik.errors.phoneNo
                      ? true
                      : false
                  }
                  helperText={
                    formik.touched.phoneNo && formik.errors.phoneNo
                      ? formik.errors.phoneNo
                      : ""
                  }
                  disabled={false}
                />
              </div>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">Instant Consult Terms & Conditions:</p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "tcFile")) {
                      formik.setFieldValue(
                        "tcFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.tc}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{tcFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">Instant Extras Terms & Conditions:</p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "instantExtrasFile")) {
                      formik.setFieldValue(
                        "instantExtrasFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.instantExtrasFile}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{instantExtrasFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">
                Doctor Service Agreement:
              </p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "dsaFile")) {
                      formik.setFieldValue(
                        "dsaFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.dsa}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{dsaFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">
                Doctor Verification Process:
              </p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "dvpFile")) {
                      formik.setFieldValue(
                        "dvpFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.dvp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{dvpFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">Privacy Policy:</p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "ppFile")) {
                      formik.setFieldValue(
                        "ppFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.pp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{ppFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">Good Practice & Safe Prescribing Policy Book:</p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "goodPracticePolicyFile")) {
                      formik.setFieldValue(
                        "goodPracticePolicyFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.goodPracticeP}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{goodPracticePolicyFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">My Health Record Security and Access Policy:</p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "myHealthRecordSecurityFile")) {
                      formik.setFieldValue(
                        "myHealthRecordSecurityFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.myHealthRecordSecurity}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{myHealthRecordSecurityFileErr}</Error>
              </p>
            </div>

            <div className="form-group row">
              <p className="col-sm-4 font-weight-bold">My Health Record Training Policy:</p>
              <p className="col-sm-5">
                <input
                  type="file"
                  onChange={event => {
                    if (validateFile(event.currentTarget.files[0], "myHealthRecordTrainingFile")) {
                      formik.setFieldValue(
                        "myHealthRecordTrainingFile",
                        event.currentTarget.files[0]
                      );
                    }
                  }}
                />
                <a
                  className="legal-link"
                  href={formik.values.myHealthRecordTraining}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
              <br />
              <p className="col-sm-12">
                <Error>{myHealthRecordTrainingFileErr}</Error>
              </p>
            </div>
            
            <div className="d-flex flex-row flex-wrap justify-content-center mt-4">
              <Button className="mb-4" title="Submit" type="submit" />
            </div>
          </form>
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  serverConstants: state.serverConstants.constants
});

const mapDispatchToProps = dispatch => ({
  getConstants: () => dispatch(getConstants())
});

export default connect(mapStateToProps, mapDispatchToProps)(EditLegalPage);
